import { render, staticRenderFns } from "./DisputeChangeEmailPage.vue?vue&type=template&id=a13e5aea&"
import script from "./DisputeChangeEmailPage.vue?vue&type=script&lang=js&"
export * from "./DisputeChangeEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports